import { Expose } from "class-transformer";

export class UpdateBankDto {
  @Expose()
  name: string;

  @Expose()
  id: string;
}
